import { render, staticRenderFns } from "./X-filtres-livraison.vue?vue&type=template&id=37656166"
import script from "./X-filtres-livraison.vue?vue&type=script&lang=js"
export * from "./X-filtres-livraison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37656166')) {
      api.createRecord('37656166', component.options)
    } else {
      api.reload('37656166', component.options)
    }
    module.hot.accept("./X-filtres-livraison.vue?vue&type=template&id=37656166", function () {
      api.rerender('37656166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/livraison/X-filtres-livraison.vue"
export default component.exports